import { render, staticRenderFns } from "./SayfaListesi.vue?vue&type=template&id=5023453b&scoped=true&"
import script from "./SayfaListesi.vue?vue&type=script&lang=js&"
export * from "./SayfaListesi.vue?vue&type=script&lang=js&"
import style0 from "./SayfaListesi.vue?vue&type=style&index=0&id=5023453b&lang=scss&scoped=true&"
import style1 from "./SayfaListesi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5023453b",
  null
  
)

export default component.exports